import { SECTION_TYPE } from "@/app/report/common/constants"
import { SectionTacticMap } from "@/app/report/common/constructor"
import type { TacticMapSettings } from "@/app/report/common/type"
import { colors } from "@/components/colors"
import type { ReportTemplate } from "@/types/report"

/**
 * Tactic Map(액션 맵 + 액션 표) 섹션 — 리포트 화면(daily/page.tsx)과 PDF 빌더(BuilderMap·BuilderActionTable)가
 * 같은 템플릿 설정을 읽기 위한 공용 헬퍼 (일감 #75, 5단계). 그리기는 양쪽 모두 TacticMapSection 컴포넌트를 쓴다.
 */

/** 템플릿에 Tactic Map 섹션이 없을 때의 기본 설정 — 설정 화면(daily/settings TacticMapSection)의 기본값과 같다 */
export const DEFAULT_TACTIC_MAP_SETTINGS: TacticMapSettings = {
  title: "Action Map",
  color: colors.red[700],
  defaultMapType: "formationMap",
  fixedColumns: ["number", "uniformNumber", "occurrence"],
  defaultActionType: "R2",
}

export type TemplateTacticMapSection = {
  /** template.content 에서의 위치 */
  index: number
  settings: TacticMapSettings
}

/** 리포트 템플릿의 Tactic Map 섹션들 (settings 는 배열이 아닌 객체) */
export const getTemplateTacticMapSections = (
  template?: ReportTemplate | null,
): TemplateTacticMapSection[] =>
  (template?.content ?? []).flatMap((section, index) =>
    section?.section === SECTION_TYPE.TACTIC_MAP &&
    section.settings &&
    !Array.isArray(section.settings)
      ? [{ index, settings: section.settings as TacticMapSettings }]
      : [],
  )

/** 아이템이 가리키는 섹션. 없거나 템플릿에서 사라졌으면 첫 섹션 */
export const resolveTemplateTacticMapSection = (
  sections: TemplateTacticMapSection[],
  sectionIndex?: number,
): TemplateTacticMapSection | null =>
  sections.find((section) => section.index === sectionIndex) ?? sections[0] ?? null

/** 설정 → TacticMapSection 이 받는 섹션 객체 (리포트 화면 createReport 의 TACTIC_MAP 분기와 동일) */
export const buildTacticMapSection = (settings: TacticMapSettings): SectionTacticMap =>
  new SectionTacticMap({ type: SECTION_TYPE.TACTIC_MAP, title: settings.title, settings })
